import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { PartnerOfferingProps } from './types';
import { styles } from './styles';
import { AnchoredTooltip, Button, Chip } from '@v2/components';

const PartnerOffering: React.FC<PartnerOfferingProps> = ({
  offering,
  activeKey,
  onChipClick,
  onEdit,
}) => {
  return (
    <div className={styles.offeringCard}>
      <div className={styles.offeringHeader}>
        <span className={styles.offeringName}>{offering.name}</span>
        {onEdit && (
          <Button
            variant="ghost-primary"
            size="sm"
            onClick={() => onEdit(offering)}
            icon={<FontAwesomeIcon icon={faEdit} />}
            aria-label="Edit offering"
          />
        )}
      </div>
      {offering.offerings.length > 0 && (
        <div className={styles.offeringTags}>
          {offering.offerings
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(bitwerxOffering => {
              const tooltipKey = `${offering.id}-${bitwerxOffering.id}`;
              const isActive = activeKey === tooltipKey;
              const hasSubOfferings = bitwerxOffering.subOfferings.length > 0;

              return (
                <AnchoredTooltip
                  key={bitwerxOffering.id}
                  isOpen={isActive && hasSubOfferings}
                  onClose={() => onChipClick('')}
                  header="Sub-offerings"
                  content={
                    <div className={styles.tooltipContent}>
                      {bitwerxOffering.subOfferings
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map(subOffering => (
                          <Chip key={subOffering.id} variant="neutral" size="sm">
                            {subOffering.displayName || subOffering.name}
                          </Chip>
                        ))}
                    </div>
                  }>
                  <Chip
                    variant="primary"
                    size="sm"
                    isActive={isActive}
                    count={hasSubOfferings ? bitwerxOffering.subOfferings.length : undefined}
                    onClick={() => onChipClick(tooltipKey)}>
                    {bitwerxOffering.name}
                  </Chip>
                </AnchoredTooltip>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default PartnerOffering;
